import { TextSelection } from '@atlaskit/editor-prosemirror/state';
import { JQLSyntaxError } from '@atlaskit/jql-ast';
import getDocumentPosition from '../../plugins/common/get-document-position';
import { getJastFromState } from '../../plugins/jql-ast';
/**
 * A Prosemirror Command that will select the first JQL error in the query if present.
 */
export var selectErrorCommand = function selectErrorCommand(state, _, view) {
  var jast = getJastFromState(state);
  var error = jast.errors.length > 0 ? jast.errors[0] : null;
  if (!(error instanceof JQLSyntaxError) || !view) {
    return false;
  }
  var transaction = state.tr;
  var documentFrom = getDocumentPosition(transaction.doc, error.start);
  var documentTo = getDocumentPosition(transaction.doc, error.stop);
  var selection = TextSelection.create(transaction.doc, documentFrom, documentTo);
  transaction.setSelection(selection);
  transaction.scrollIntoView();
  view.focus();
  view.dispatch(transaction);
  return true;
};